import ZlbConfirm from '@/components/ZlbConfirm';
import {
  reqDetail,
  reqTimeLine,
  reqList,
  // reqRemind,
  reqDelete,
  reqAdd,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = (res) => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'claimList',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
      invoiceType: 1,
      realStatus: 0,
      search: {
        inputValue: 'inputValue',
        selectValue: 2,
      },
      businessType: 1,
      applyUserDeptName: '业务部门',
      Ttime: {
        code: 'customTime',
        issueBeginTime: 1625138380000,
        issueEndTime: 1625656780000,
      },
      // Ttime: { code: '1' },
    },
    list: {},
    detail: {},
    timeLine: [],
  },
  effects: {
    * fetchDetail ({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      if (!responseErrorHandle(res)) {
        return res;
      }

      yield put({
        type: 'update',
        payload: {
          detail: res.result,
        },
      });
    },
    * fetchTimeline ({ payload }, { call, put }) {
      const res = yield call(reqTimeLine, payload);
      if (!responseErrorHandle(res)) {
        return res;
      }

      yield put({
        type: 'update',
        payload: {
          timeLine: res.result,
        },
      });
    },
    * fetchList ({ payload }, { call, put }) {
      const res = yield call(reqList, payload);
      if (!responseErrorHandle(res)) {
        return res;
      }

      yield put({
        type: 'update',
        payload: {
          list: res.result,
        },
      });
    },
    // *remind({ payload }, { call }) {
    //   const res = yield call(reqRemind, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },
    * delete ({ payload }, { call }) {
      const res = yield call(reqDelete, payload);
      responseErrorHandle(res);
      return res;
    },
    * add ({ payload }, { call }) {
      const res = yield call(reqAdd, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
